import * as Sentry from '@sentry/react'
import { isInProduction, SENTRY_DSN, SENTRY_ENVIRONMENT } from '../config'

if (SENTRY_DSN && SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    _experiments: { enableLogs: true },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
      Sentry.browserSessionIntegration(),
    ],
    tracesSampleRate: isInProduction ? 1.0 : 0.05,
    profilesSampleRate: isInProduction ? 1.0 : 0.02,
    replaysSessionSampleRate: isInProduction ? 0.02 : 0.01,
    replaysOnErrorSampleRate: isInProduction ? 1.0 : 0.1,
    tracePropagationTargets: [window.location.origin],
    sendDefaultPii: true,
    attachStacktrace: true,
  })
}
